import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAddressCard } from "@fortawesome/free-solid-svg-icons";
import Register from "../Images/register.svg";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import { encrypt, passwordToEmojiSeed } from "./encrypt";

function RegisterPage() {
  const [input, setInput] = useState("");
  let navigate = useNavigate();

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-12 col-sm-6">
          <div className="card text-center">
            <div className="card-body">
              <p className="card-title display-6 gray">Register</p>
              <div className="img">
                <img
                  src={Register}
                  width="260"
                  height="230"
                  className=""
                  alt="register"
                />
              </div>
              <input
                className={"form-control form-control-lg my-3 text-center"}
                id="preview"
                name="preview"
                placeholder="Preview"
                autoFocus
                disabled
                value={input.length ? passwordToEmojiSeed(input) : ""}
              />
              <input
                className={"form-control my-3 text-center"}
                id="password"
                name="password"
                placeholder="Password"
                autoFocus
                onChange={(e) => setInput(e.target.value)}
              />
              <div className="d-grid gap-2">
                <button
                  type="submit"
                  className="bttn"
                  onClick={() => {
                    if (input.length) {
                      // add hashing
                      localStorage.setItem("key", encrypt(input));
                      localStorage.setItem("pkey", input);

                      Swal.fire({
                        title: "Success",
                        text: `Successfully registered`,
                        icon: "success",
                        confirmButtonText: "Log In",
                      }).then(() => navigate("/"));
                    } else
                      Swal.fire({
                        title: "Error",
                        text: `Password not set`,
                        icon: "error",
                        confirmButtonText: "Dismiss",
                      });
                  }}
                >
                  <FontAwesomeIcon icon={faAddressCard} /> Register
                </button>
              </div>
            </div>
            <div className="card-footer text-muted text-center link">
              Already registered? <Link to="/">Log In</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegisterPage;
